import actionTypes from 'redux/actionTypes';

export function getRefreshTime(data) {
	return {
		type: actionTypes.GET_REFRESH_TIME,
		payload: data
	};
}

export function getRefreshTimeSuccess(result) {
	return {
		type: actionTypes.GET_REFRESH_TIME_SUCCESS,
		payload: result
	};
}

export function getRefreshTimeFailure(error) {
	return {
		type: actionTypes.GET_REFRESH_TIME_FAILURE,
		payload: error
	};
}

export function resetScheduleReportError() {
	return {
		type: actionTypes.RESET_SCHEDULE_REPORT_ERROR
	};
}
export function canUserCreateReport(payload) {
	return {
		type: actionTypes.USER_CAN_CREATE_REPORT,
		payload
	};
}
export function canUserCreateReportSuccess(payload) {
	return {
		type: actionTypes.USER_CAN_CREATE_REPORT_SUCCESS,
		payload
	};
}
export function canUserCreateReportFailure() {
	return {
		type: actionTypes.USER_CAN_CREATE_REPORT_FAILURE
	};
}
